import { render } from "./MovementsView.vue?vue&type=template&id=3fa1f923&scoped=true"
import script from "./MovementsView.vue?vue&type=script&lang=js"
export * from "./MovementsView.vue?vue&type=script&lang=js"

import "./MovementsView.vue?vue&type=style&index=0&id=3fa1f923&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa1f923"]])

export default __exports__